import React from "react";
import doctorImage from "../assets/doctor-hero.jpg";

const heroImage = doctorImage;

const Hero = () => (
  <>
    <style>{`
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes float {
        0%, 100% {
          transform: translateY(0px);
        }
        50% {
          transform: translateY(-20px);
        }
      }

      @keyframes glow {
        0%, 100% {
          box-shadow: 0 0 20px rgba(31, 181, 181, 0.3);
        }
        50% {
          box-shadow: 0 0 40px rgba(31, 181, 181, 0.6);
        }
      }

      @keyframes shimmer {
        0% {
          background-position: -1000px 0;
        }
        100% {
          background-position: 1000px 0;
        }
      }

      .hero-badge {
        animation: fadeInUp 0.8s ease-out;
      }

      .hero-title {
        animation: fadeInUp 0.8s ease-out 0.2s both;
      }

      .hero-text {
        animation: fadeInUp 0.8s ease-out 0.4s both;
      }

      .hero-buttons {
        animation: fadeInUp 0.8s ease-out 0.6s both;
      }

      .hero-features {
        animation: fadeInUp 0.8s ease-out 0.8s both;
      }

      .feature-card {
        animation: float 3s ease-in-out infinite;
        transition: all 0.4s ease;
      }

      .feature-card:hover {
        transform: translateY(-25px) scale(1.05);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
      }

      .btn-primary {
        position: relative;
        overflow: hidden;
      }

      .btn-primary::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
        animation: shimmer 2s infinite;
      }

      .btn-glow {
        animation: glow 2s ease-in-out infinite;
      }
    `}</style>

    <section
      id="home"
      className="relative overflow-hidden min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/25" />

      <div className="relative max-w-7xl mx-auto px-6 py-24 w-full">
        <div className="max-w-2xl">
          <div className="hero-badge inline-flex items-center gap-2 bg-white/90 border border-[#0D9DAD]/30 rounded-full px-4 py-1.5 text-xs font-semibold text-[#1A7A7A] mb-6 backdrop-blur-sm">
            <span className="w-2 h-2 bg-[#0D9DAD] rounded-full animate-pulse" />
            Welcome To HelaDoc
          </div>

          <h1 className="hero-title font-playfair text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight text-white mb-6">
            AI-Powered Integrated<br />
            <span className="text-[#0D9DAD]">HealthCare EcoSystem</span>
          </h1>

          <p className="hero-text text-white/90 text-base sm:text-lg leading-relaxed mb-10 max-w-xl">
            HelaDoc is an AI-powered telemedicine platform offering remote consultations, online pharmacy and lab integration, instant insurance claim submission & tracking, medical imaging analysis, AI-assisted diagnostics, psychiatric support, and an islandwide healthcenter network.
          </p>

          <div className="hero-buttons flex flex-wrap gap-4 mb-8">
            <a href="#about" className="btn-primary bg-[#0D9DAD] hover:bg-[#1A7A7A] text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-lg">What is HelaDoc?</a>
            <a href="#services" className="btn-outline border-2 border-white/50 hover:border-white text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:bg-white/10 backdrop-blur-sm">Explore Features</a>
          </div>

          <div className="hero-features grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl">
            {[
              "Video & audio consultations",
              "Online pharmacy & lab integration",
              "Instant insurance claim tracking",
              "Medical imaging analysis",
              "AI-assisted diagnostics",
              "Psychiatric support & care"
            ].map((item, idx) => (
              <div 
                key={item} 
                className="feature-card rounded-3xl border border-white/30 bg-white/20 p-4 text-sm text-white/90 backdrop-blur-sm"
                style={{ animationDelay: `${idx * 0.2}s` }}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Hero;
